<template>
  <base-dialog
    :action="onAction"
    :action-name="'Update status'"
    :close="onClose"
    :title="'Change invoice status'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-row>
        <v-col cols="12">
          <v-radio-group v-model="radios" :mandatory="false">
            <v-radio
              label="Paid"
              value="paid"
              color="primary"
            ></v-radio>
            <div class="ml-8 mb-5 grey--text">
              Payment was collected outside of the platform.
            </div>
            <v-radio
              label="Void"
              value="void"
              color="primary"
            ></v-radio>
            <div class="ml-8 mb-5 grey--text">
              This invoice was accidentally finalized or contains a mistake.
            </div>
            <v-radio
              v-if="invoice.status !== 'uncollectible'"
              label="Uncollectible"
              value="uncollectible"
              color="primary"
            ></v-radio>
            <div class="ml-8 mb-5 grey--text" v-if="invoice.status !== 'uncollectible'">
              Payment of this invoice is not expected. It is still possible to collect payment
              should your customer attempt to pay.
            </div>
          </v-radio-group>
        </v-col>
      </v-row>
    </template>

  </base-dialog>
</template>
<script>
import BaseDialog from "../Common/BaseDialog"
import { mapActions } from 'vuex'

export default {
  props: {
    invoice: {
      type: Object,
      default: () => ({})
    }
  },
  components: { BaseDialog },
  data() {
    return {
      radios: null
    }
  },
  methods: {
    ...mapActions([ 'voidInvoice', 'paidInvoice', 'uncollectibleInvoice' ]),
    async onAction() {

      if (this.radios) {
        const payload = {
          id: this.invoice.id,
          expand: [
            'payment_intent.charges.data.balance_transaction',
            'customer',
            'total_tax_amounts.tax_rate'
          ]
        }

        let result = null
        if (this.radios === 'void') {
          result = await this.voidInvoice(payload)
        } else if (this.radios === 'uncollectible') {
          result = await this.uncollectibleInvoice(payload)
        } else if (this.radios === 'paid') {
          result = await this.paidInvoice(payload)
        }

        if (result) {
          this.$emit('action', result)
        }
      }
    },
    onClose() {
      this.$emit('close')
    },
  }
}
</script>
